import { brl, imgUrl } from "@/lib/api";
import { effPrice, hasPromo } from "@/lib/shop";
import { cn } from "@/lib/utils";

export function ShopProductCard({ p, color, onOpen }) {
  const promo = hasPromo(p);
  const off = p.available === false;
  return (
    <button onClick={() => !off && onOpen(p)} className={cn("flex w-full gap-4 rounded-xl border border-slate-200 bg-white p-4 text-left transition-shadow hover:shadow-md sm:p-5", off && "cursor-not-allowed opacity-60")} data-testid={`shop-product-${p.id}`}>
      <div className="flex min-w-0 flex-1 flex-col">
        <p className="font-semibold text-slate-900 sm:text-lg">{p.name}</p>
        {p.description && <p className="mt-2 line-clamp-3 text-sm text-slate-500">{p.description}</p>}
        <div className="mt-auto flex flex-wrap items-baseline gap-2 pt-4">
          {promo && <span className="text-sm text-slate-400 line-through">{brl(p.price)}</span>}
          <span className={cn("sm:text-lg", promo ? "font-bold" : "text-slate-800")} style={promo ? { color } : {}} data-testid={`shop-product-price-${p.id}`}>{p.option_groups?.length ? "A partir de " : ""}{brl(effPrice(p))}</span>
          {off && <span className="text-xs font-semibold text-red-500">Indisponível</span>}
        </div>
      </div>
      {p.image_url && (
        <div className="relative h-28 w-28 shrink-0 overflow-hidden rounded-lg bg-slate-100 sm:h-40 sm:w-40">
          <img src={imgUrl(p.image_url)} alt={p.name} loading="lazy" className="h-full w-full object-cover" />
          {promo && <span className="absolute left-1.5 top-1.5 rounded-full px-2 py-0.5 text-[11px] font-bold text-white" style={{ background: color }}>-{Math.round((1 - effPrice(p) / p.price) * 100)}%</span>}
        </div>
      )}
    </button>
  );
}

export function ShopSection({ id, title, description, items, color, onOpen }) {
  if (!items.length) return null;
  return (
    <section id={id} className="scroll-mt-24 space-y-4" data-testid={`shop-section-${id}`}>
      <div>
        <h2 className="text-2xl font-bold text-slate-900 sm:text-3xl">{title}</h2>
        {description && <p className="mt-2 text-slate-500">{description}</p>}
      </div>
      <div className="grid gap-4 md:grid-cols-2">{items.map((p) => <ShopProductCard key={`${id}-${p.id}`} p={p} color={color} onOpen={onOpen} />)}</div>
    </section>
  );
}
